(() => {
    const text = 'Suscríbete y recibe una nueva caja PAHU cada dos meses\u00A0';

    const apply = () => {
    const containers = document.querySelectorAll('.sls-option-container');
    const second = containers[1];
    const label = second?.querySelector('label.sls-selling-plan-group-name');
    if (!label) return false;
    label.textContent = text;
    return true;
    };

    const run = () => {
    if (apply()) return;

    // Seal often injects markup after DOMContentLoaded; observe until present.
    const obs = new MutationObserver(() => {
        if (apply()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
    run();
    }
})();